/// <reference types="@angular/localize" />

import {enableProdMode} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import {environment} from '@env/environment';

declare let __webpack_public_path__: any;

if (environment.production) {
  __webpack_public_path__ = window['STATIC_URL_MODULE'] + 'generated-collector/';
  enableProdMode();

  Sentry.init({
    dsn: "https://65e15b616b3da7a8609560bcf621ab06@o4509965493600256.ingest.us.sentry.io/4509965638303744",
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    sendDefaultPii: true,
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^http:\/\/local\.spryng\.io/,
      /^http:\/\/local\.scrumdo\.com/,
      /^https:\/\/app\.spryng\.io\/api/
    ]
  });

}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
